import { id } from '@monorepo/tools/src/lib/types/primitives';
import { makeAutoObservable } from 'mobx';

export interface IAccount {
	id?: id;
	name?: string;
	use_internal_pricing?: boolean;
	use_calc_payout?: boolean;
}

/** API payloads may use snake_case or camelCase for the pricing flag. */
export type IAccountInput =
	| IAccount
	| (Omit<IAccount, 'use_internal_pricing' | 'use_calc_payout'> & {
			useInternalPricing?: boolean;
			useCalcPayout?: boolean;
	  });

export function resolveUseInternalPricing(account?: { use_internal_pricing?: boolean; useInternalPricing?: boolean }): boolean | undefined {
	return account?.use_internal_pricing ?? account?.useInternalPricing;
}

export function resolveUseCalcPayout(account?: { use_calc_payout?: boolean; useCalcPayout?: boolean }): boolean | undefined {
	return account?.use_calc_payout ?? account?.useCalcPayout;
}

export type ICreateAccount = Omit<IAccount, 'id'>;

export class AccountsModel implements IAccount {
	id?: id;
	name?: string;
	use_internal_pricing?: boolean;
	use_calc_payout?: boolean;

	constructor(account?: IAccountInput) {
		this.id = account?.id;
		this.name = account?.name;
		this.use_internal_pricing = resolveUseInternalPricing(account);
		this.use_calc_payout = resolveUseCalcPayout(account);

		makeAutoObservable(this);
	}

	getId() {
		return this.id;
	}

	getName() {
		return this.name;
	}

	getUseInternalPricing() {
		return this.use_internal_pricing;
	}

	setId(id: id) {
		this.id = id;
	}

	setName(name: string) {
		this.name = name;
	}

	setUseInternalPricing(v: boolean) {
		this.use_internal_pricing = v;
		if (!v) {
			this.use_calc_payout = false;
		}
	}

	getUseCalcPayout() {
		return this.use_calc_payout;
	}

	setUseCalcPayout(v: boolean) {
		if (v && !this.use_internal_pricing) {
			this.use_calc_payout = false;
			return;
		}
		this.use_calc_payout = v;
	}
}
